import loadable from '@loadable/component';

import { CmsApiFourArticlesHighlightBlockData } from 'modules/cms/api/types/blocks/CmsApiFourArticlesHighlightBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsFourArticlesHighlightBlockMapping: CmsBlockMapping<CmsApiFourArticlesHighlightBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsFourArticlesHighlightBlock'), {
        resolveComponent: (module) => module.CmsFourArticlesHighlightBlock,
      }),
    ),
    AmpComponent: loadable(() => import('./CmsAmpFourArticlesHighlightBlock'), {
      resolveComponent: (module) => module.CmsAmpFourArticlesHighlightBlock,
    }),
  };
